import type { StackProps } from '@mui/material'
import { ToggleButton } from '@mui/material'
import React from 'react'

import type { ToggleButtonGroupControllerProps } from '@/components/inputs/ToggleButtonGroupController'
import ToggleButtonGroupController from '@/components/inputs/ToggleButtonGroupController'
import { ConfigField } from '@/features/controller/configuration/components/drawers/ConfigField'

type EnumValue = string | number
type EnumLike = Readonly<Record<string, EnumValue>>

type ToggleButtonGroupEnumConfigFieldProps = Omit<StackProps, 'flexDirection' | 'gap'> & {
  enumLabels?: EnumLike
  enumType: EnumLike
  helpTooltip?: string
  label: string
  name: string
  toggleButtonGroupControllerProps?: Omit<ToggleButtonGroupControllerProps<any, any>, 'name'>
}

export function ToggleButtonGroupEnumConfigField({
  enumLabels,
  enumType,
  helpTooltip,
  label,
  name,
  toggleButtonGroupControllerProps,
  ...stackProps
}: Readonly<ToggleButtonGroupEnumConfigFieldProps>) {
  return (
    <ConfigField {...stackProps} helpTooltip={helpTooltip} label={label}>
      <ToggleButtonGroupController {...toggleButtonGroupControllerProps} name={name}>
        {Object.keys(enumType).map((key) => (
          <ToggleButton key={key} value={enumType[key]}>
            {enumLabels ? enumLabels[key] : enumType[key]}
          </ToggleButton>
        ))}
      </ToggleButtonGroupController>
    </ConfigField>
  )
}
